import { $get, $movaGet } from '../axios';
import axios from 'axios';

// 地图数据总览-总览
export const getMapAllOverview = params => {
  return $get('/creator/', { act: 'get_all_map_overview', ...params });
};
// 资源数据总览-总览
export const getResAllOverview = params => {
  return $get('/creator/', { act: 'get_res_all_overview', ...params });
};
// 地图列表
export const getMapList = params => {
  return $get('/creator/', { act: 'get_map_list', ...params });
};
// 地图详情
export const getMapDetail = params => {
  return $get('/creator/', { act: 'get_map_overview', ...params });
};
// 资源详情
export const getResourceDetail = params => {
  return $get('/creator/', { act: 'view_res_detail', ...params });
};
// 地图详情-曲线图
export const getMapDiagram = params => {
  return $get('/creator/', { act: 'get_map_diagram', ...params });
};
// 资源详情-曲线图
export const getResDiagram = params => {
  return $get('/creator/', { act: 'get_res_diagram', ...params });
};
// 下载
export const exportMapData = params => {
  return $get('/creator/', { act: 'export_map_data', ...params });
};
// 下载自定义埋点数据
export const exportMapCustomData = params => {
  return $get('/creator/', { act: 'export_map_stats', ...params });
};
export const downloadData = params => {
  return $get('/creator/', { act: 'export_maps_ugc', ...params });
};
// 资源数据(单个资源)-下载
export const downloadResourceData = params => {
  return $get('/creator/', { act: 'export_res_list', ...params });
};
// 资源数据总览-下载
export const downloadResourceList = params => {
  return $get('/creator/', { act: 'export_res_list_overview', ...params });
};
//曝光转化数据
export const getExportsureData = params => {
  return $get('/creator/', { act: 'get_map_ad_exposure', ...params });
};
//获取活跃数据
export const getActiveData = params => {
  return $get('/creator/', { act: 'get_maps_ugc', ...params });
};
// 资源-作品列表
export const getResourceList = params => {
  return $get('/creator/', { act: 'get_res_list_overview', ...params });
};
//获取用户所有地图激励数据
export const getMotivate = params => {
  return $movaGet('/encourage/', { web: 'all', ...params });
};
//获取单张地图激励数据
export const getSinMotivate = params => {
  return $movaGet('/encourage/', { web: 'single', ...params });
};
//获取单张地图激励数据
export const setCloseRoom = params => {
  return $get('/creator/', { act: 'close_room', ...params });
};
//获取单张地图日维度数据
export const getMapDaysDetail = params => {
  return $get('/creator/', { act: 'get_platform_stats_day', ...params });
};
//获取单张地图周维度数据
export const getMapWeeksDetail = params => {
  return $get('/creator/', { act: 'get_platform_stats_week', ...params });
};
//获取单张地图月维度数据
export const getMapMonthsDetail = params => {
  return $get('/creator/', { act: 'get_platform_stats_month', ...params });
};
//获取玩家数据来源与曝光数据
export const getMapExposureFrom = params => {
  return $get('/creator/', { act: 'get_map_exposure_from', ...params });
};
// KV 异常数据 获取KV异常数据数据
export const getMapKVData = params => {
  console.log('params', params);
  return $get('/creator/', { act: 'get_map_kv_error', ...params });
};
// 获取 kv 全部日志
export const getMapKVAllLogs = params => {
  console.log('params', params);
  return $get('/creator/', {
    act: 'get_map_player_kv_log',
    ...params,
  });
};
// 获取 kv 可回档日志
export const getMapKVCanRollbackLogs = params => {
  console.log('params', params);
  return $get('/creator/', {
    act: 'get_map_player_rollback_kv_log',
    ...params,
  });
};
// kv 回档
export const mapKVCanRollback = params => {
  console.log('params', params);
  return $get('/creator/', {
    act: 'map_player_rollback_kv_data',
    ...params,
  });
};
// kv 回档记录
export const getMapKVRollbackLog = params => {
  console.log('params', params);
  return $get('/creator/', {
    act: 'get_map_player_rollback_kv_op_log',
    ...params,
  });
};
// 获取 ss_lua_error 数据
export const getSsLuaErrorData = params => {
  console.log('params', params);
  return $get('/creator/', {
    act: 'get_map_player_ss_lua_error_log',
    ...params,
  });
};
// 地图数据-查询studio地图日志文件列表
export const getStudioMapLogFiles = params => {
  console.log('params', params);
  return $get('/creator/', {
    act: 'get_studio_map_logfiles',
    ...params,
  });
};
// 地图数据-预下载studio地图日志文件(获取下载地址和token)
export const studioMapPreDownload = params => {
  console.log('params', params);
  return $get('/creator/', {
    act: 'studio_map_pre_download',
    ...params,
  });
};
// 地图数据-下载studio地图日志文件（拿到下载地址和token后调用这个接口）
export const studioMapDownload = params => {
  return axios.get(params.url, {
    headers: { Authorization: `Bearer ${params.token}` },
  });
};

// 地图数据-查询cpu监控日志文件列表
export const getCpuLogList = params => {
  return $get('/creator/', {
    act: 'get_map_performance_data',
    ...params,
  });
};
export const exportMapKVData = params => {
  return $get('/creator/', { act: 'export_map_kv_error', ...params });
};
export const getMapKVAppId = params => {
  return $get('/creator/', { act: 'get_map_appid', ...params });
};
export const saveMapBlackList = params => {
  return $get('/creator/', { act: 'set_map_black_uin_list', ...params });
};
export const getMapBlackList = params => {
  return $get('/creator/', { act: 'get_map_black_uin_list', ...params });
};
